import {
    IS_LOGIN_LOADING,
    LOGIN_HAS_ERROR,
    LOGIN_FETCH_DATA_SUCCESS,
    INITIAL_LOGIN_COMPLETED,
    UPDATE_USER_TOKEN,
    UPDATE_USER_PROFILE,
    GAMING_HUB_LOADED
} from './../constants/action-types';
import { login } from "../constants/api-url";
import common from './../common';

export function initialDetailsCompleted(bool) {
    return {
        type: INITIAL_LOGIN_COMPLETED,
        payload: bool
    };
}

export function isLoginLoading(bool) {
    return {
        type: IS_LOGIN_LOADING,
        payload: bool
    };
}

export function loginHasError(bool) {
    return {
        type: LOGIN_HAS_ERROR,
        payload: bool
    };
}

export function loginSuccess(response) {
    return {
        type: LOGIN_FETCH_DATA_SUCCESS,
        payload: response
    };
}

export function saveUserToken(response) {
    return {
        type: UPDATE_USER_TOKEN,
        payload: response
    };
}

export function saveUserProfile(response) {
    return {
        type: UPDATE_USER_PROFILE,
        payload: response
    };
}

export function makeLogin(loginPayload) {
    return (dispatch) => common.makeAPICall(login, dispatch, isLoginLoading, loginSuccess, loginHasError, loginPayload, 'POST');
}

export function makeLoginTemp(loginPayload) {
    return (dispatch) => common.makeAPICall(login, dispatch, isLoginLoading, loginSuccess, loginHasError, loginPayload, 'POST');
}

export function setGamingHubStatus(bool) {
    return {
        type: GAMING_HUB_LOADED,
        payload: bool
    };
}




// WEBPACK FOOTER //
// ./src/actions/AuthActions.js